import type { Role } from '@ready/shared';

export const isManager = (role: Role | null | undefined) => role === 'admin' || role === 'owner';
export const isAuthor = (role: Role | null | undefined) => role === 'author' || isManager(role);
